import React, { useRef } from "react";
import { useTranslation, Trans } from "react-i18next";
import { VscArrowDown, VscRocket  } from "react-icons/vsc";
import pensativa from "../../assets/pensativa-s.webp";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import "./About.scss";

const About = () => {
  const {t} = useTranslation();
  const img = useRef(null);
  const text = useRef(null);
  const btn1 = useRef(null);
  const btn2 = useRef(null);

  useGSAP(() => {
    gsap.fromTo(img.current, { scale: 0 }, { scale: 1, duration: 2, ease: "elastic" });
    gsap.fromTo(text.current, { opacity: 0, xPercent: -100 }, { opacity: 1, xPercent: 0, duration: 1, ease: "slow", delay: 0.8 });
    gsap.fromTo(btn1.current, { opacity: 0 }, { opacity: 1, duration: 1, ease: "slow", delay: 1.3 });
    gsap.fromTo(btn2.current, { opacity: 0 }, { opacity: 1, duration: 1, ease: "slow", delay: 1.5 });
  });

  const scrollTo = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault();
    const href = e.currentTarget.getAttribute('href');
    if ( !href ) return;
    const element = document.getElementById(href.replace('#', ''));
    if ( !element ) return;
    window.scroll({
      top: element.offsetTop - 20,
      behavior: 'smooth'
    });
  };

  return (
    <section id="home" className="about">
      <div className="about__container container h-full">
        <div className="about__text" ref={text}>
          <h1 className="about__title app__title">
            <Trans i18nKey="title">
              MARIIA OPANASENKO
            </Trans>
          </h1>
          <h2 className="about__subtitle">Fronted | React | Web developer</h2>
          <div className="about__buttons">
            <a
              className="button about__button"
              href="#contacts"
              ref={btn1}
              onClick={(e) => scrollTo(e)}
            >
              <VscRocket  /> {t('buttons.button1')}
            </a>
            <a 
              href="#works" 
              className="button button--secondary"
              ref={btn2}
              onClick={(e) => scrollTo(e)}
            >
              <VscArrowDown /> {t('buttons.button2')}
            </a>
          </div>
        </div>
        <div 
          className="about__image"
          ref={img}
        >
          <img
            src={`${pensativa}`}
            alt="Mariia"
            width={550}
            height={550}
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
};

export default About;
